import React from "react";
import Avatar from "@mui/material/Avatar";
import "./Card.css";
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";

export default function PremiumCard({ state, onClick }) {
  React.useEffect(() => {
    if (state) {
        document.getElementById("premiumCard").classList.add("activateCard");
    } else {
        document.getElementById("premiumCard").classList.remove("activateCard");
    }
    return () => {
    };
  }, [state]);
  return (
    <div className="" onClick={onClick}>
      <div id="premiumCard" className="card col-md-12 col-12 ms-md-1">
        <div className="d-flex aligns-items-center justify-content-center">
          <Avatar sx={{ bgcolor: "green" }}>
            <CurrencyRupeeRoundedIcon />
          </Avatar>
        </div>
        <p className="membership-type d-flex aligns-items-center justify-content-center">
          Premium
        </p>
        <div className="d-flex aligns-items-center justify-content-center">
          <i>500</i>
        </div>
      </div>
    </div>
  );
}
